import { useSettingsStore } from '@/store/modules/settings';
export default {
  __name: 'index',
  props: {
    collapse: {
      type: Boolean,

      default() {
        return false;
      }

    },
    fixedHeader: {
      type: Boolean,

      default() {
        return true;
      }

    },
    showTabs: {
      type: Boolean,

      default() {
        return true;
      }

    },
    device: {
      type: String,

      default() {
        return 'desktop';
      }

    }
  },

  setup(__props, {
    expose
  }) {
    expose();
    const settingsStore = useSettingsStore();
    const {
      foldSideBar
    } = settingsStore;
    const __returned__ = {
      settingsStore,
      foldSideBar,
      useSettingsStore
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }

};